<script setup lang="ts">
const route = useRoute()
const formula = route.params.formula as string
const category = route.params.category as string

const { styles } = useVariants('page')
const theme = useTheme()

const { data, error, status } = useFetch<LanguagesResponse>(
  `/api/menu/${formula}/${category}`,
)

watch(error, (err) => {
  if (err) showError({ statusCode: err.statusCode ?? 500, fatal: true })
}, { immediate: true })

watch(() => data.value?.theme?.url, (url) => {
  if (url) theme.value = toThemeName(url)
}, { immediate: true, flush: 'sync' })

useHead(() => ({
  bodyAttrs: {
    'data-theme': theme.value,
  },
}))
</script>

<template>
  <section :class="styles.section()">
    <div :class="styles.container()">
      <!-- Loading state -->
      <template v-if="status === 'pending'">
        <Spinner />
      </template>

      <!-- Success state -->
      <template v-else-if="data?.languages.length">
        <ThemeLogo />

        <!-- Title -->
        <h1 :class="styles.heading()">
          {{ $t("menu") }}
        </h1>

        <!-- Languages -->
        <ul v-if="data?.languages.length" class="flex w-full flex-col gap-3">
          <li v-for="lang in data.languages" :key="lang.id" class="w-full">
            <LanguageButton :to="`/${formula}/${category}/${lang.short}`" :label="lang.name" />
          </li>
        </ul>
      </template>
    </div>
  </section>
</template>
